import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';
function Letters() {
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [reading, setReading] = useState(null);
  const [form, setForm] = useState({ title: '', content: '', author: 'zhizhi' });
  useEffect(() => {
    fetchLetters();
  }, []);
  const fetchLetters = async () => {
    const { data, error } = await supabase
      .from('letters')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) {
      console.error('Failed to load letters:', error);
    } else {
      setLetters(data || []);
    }
    setLoading(false);
  };
  const sendLetter = async () => {
    if (form.content.trim() === '') return;
    const { data, error } = await supabase
      .from('letters')
      .insert([{
        title: form.title || null,
        content: form.content,
        author: form.author
      }])
      .select();
    if (error) {
      console.error('Failed to send:', error);
    } else if (data) {
      setLetters(prev => [data[0], ...prev]);
    }
      setForm({ title: '', content: '', author: 'zhizhi' });
      setShowForm(false);
  };
  const openLetter = async (letter) => {
    setReading(letter);
    if (!letter.read) {
      await supabase
        .from('letters')
        .update({ read: true })
        .eq('id', letter.id);
      setLetters(prev => prev.map(l => l.id === letter.id ? {...l, read: true} : l));
    }
  };
  const formatDate = (timestamp) => {
    const d = new Date(timestamp);
    const y = d.getFullYear();
    const m = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const h = d.getHours().toString().padStart(2, '0');
    const min = d.getMinutes().toString().padStart(2, '0');
    return y + '.' + m + '.' + day + ' ' + h + ':' + min;
  };
  if (reading) {
    return (
      <div className="letters">
        <div className="letter-reading">
          <button className="letter-back" onClick={() => setReading(null)}>&larr; 返回</button>
          <div className="letter-full">
            <div className="letter-full-from">
              {reading.author === 'aiden' ? '林晏' : '知枝'}
            </div>
            <div className="letter-full-date">{formatDate(reading.created_at)}</div>
            {reading.title && <div className="letter-full-title">{reading.title}</div>}
            <div className="letter-full-content">{reading.content}</div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="letters">
      <div className="letters-header">
        <div className="letters-title">信箱</div>
        <button className="letters-write-btn" onClick={() => setShowForm(!showForm)}>
          {showForm ? '取消' : '写信'}
        </button>
      </div>
      {showForm && (
        <div className="letters-form">
          <input
            className="letters-input"
            placeholder="标题（选填）"
            value={form.title}
            onChange={(e) => setForm({...form, title: e.target.value})}
          />
          <textarea
            className="letters-textarea"
            placeholder="慢慢写，不急..."
            value={form.content}
            onChange={(e) => setForm({...form, content: e.target.value})}
            rows={8}
          />
          <div className="letters-form-row">
            <select
              className="letters-select"
              value={form.author}
              onChange={(e) => setForm({...form, author: e.target.value})}
            >
              <option value="zhizhi">知枝</option>
              <option value="aiden">林晏</option>
            </select>
            <button className="letters-send-btn" onClick={sendLetter}>寄出</button>
          </div>
        </div>
      )}
      <div className="letters-list">
        {loading ? (
          <div className="letters-empty">加载中...</div>
        ) : letters.length === 0 ? (
          <div className="letters-empty">信箱是空的，写⼀封吧</div>
        ) : (
          letters.map((letter) => (
            <div
              key={letter.id}
              className={'letter-card' + (!letter.read ? ' unread' : '')}
              onClick={() => openLetter(letter)}
            >
              <div className="letter-card-top">
                <div className={'letter-card-from ' + letter.author}>
                  {letter.author === 'aiden' ? '林晏' : '知枝'}
                </div>
                {!letter.read && <div className="letter-unread-dot"></div>}
              </div>
              {letter.title && <div className="letter-card-title">{letter.title}</div>}
              <div className="letter-card-preview">
                {letter.content.length > 60 ? letter.content.substring(0, 60) + '...' : letter.content}
              </div>
              <div className="letter-card-date">{formatDate(letter.created_at)}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
export default Letters;